import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function createPasswordSuccess(draft: Draft<IAuthData>) {
  draft.createPassword.config.isLoading = false;
}

export default createPasswordSuccess;
